<template>
  <v-row>
    <v-col cols="12" md="7">
      <v-text-field v-model="tpl.name" outlined dense label="Report name" counter="120" />
      <v-textarea v-model="tpl.description" outlined dense rows="2" auto-grow counter="400"
        label="Short description (shown on the report card)" hint="One or two plain-language sentences for the person choosing the report." persistent-hint />
      <v-text-field v-model="tpl.key" class="mt-4" outlined dense label="Report key"
        hint="Unique id used by exports/imports and URLs: lowercase letters, numbers, dots, dashes (e.g. sales.daily-summary)" persistent-hint />
      <v-row dense class="mt-2">
        <v-col cols="12" sm="7">
          <v-combobox v-model="tpl.category" :items="categoryNames" outlined dense label="Category" hint="Pick one or type a new category" persistent-hint />
        </v-col>
        <v-col cols="12" sm="5">
          <v-text-field v-model.number="tpl.order" type="number" outlined dense label="Order within category" hint="Smaller numbers first" persistent-hint />
        </v-col>
      </v-row>
      <v-combobox v-model="tpl.tags" class="mt-4" multiple chips small-chips deletable-chips outlined dense label="Search tags" />
    </v-col>

    <v-col cols="12" md="5">
      <v-card outlined>
        <v-card-title class="text-subtitle-1">Visibility & access</v-card-title>
        <v-card-text>
          <v-radio-group v-model="tpl.visibility" dense class="mt-0">
            <v-radio value="draft" label="Draft - only Super Admin can see it" />
            <v-radio value="published" label="Published - visible to the user types below" />
            <v-radio value="hidden" label="Hidden - kept but not listed" />
          </v-radio-group>
          <v-select
            v-model="tpl.permissions.userTypeIds" :items="userTypes" item-text="name" item-value="id" multiple chips small-chips deletable-chips
            outlined dense label="Who can open it (published)" hint="Leave empty to allow everyone who has report access" persistent-hint
          />
          <v-switch v-model="tpl.urlFilters" dense inset class="mt-4" label="Keep filter choices in the page address" />
          <div class="text-caption grey--text">Lets people use back/forward, bookmark or share a link that restores the same filters.</div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { state } from './editorState'

export default {
  name: 'RbGeneralTab',
  computed: {
    tpl () { return state.tpl },
    categoryNames () { return state.categories.map((c) => c.name) },
    userTypes () { return (state.meta && state.meta.userTypes) || [] }
  }
}
</script>
